module.exports = __webpack_public_path__ + "img/home.17e8171f.svg";